var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"mfa-container"},[_c('authentication-methods',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMFAComplete),expression:"!isMFAComplete"}],attrs:{"isMfaView":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }